
// You can write more code here

/* START OF COMPILED CODE */

export default class HeartContainer extends Phaser.GameObjects.Container {

	constructor(scene: Phaser.Scene, x?: number, y?: number) {
		super(scene, x ?? 0, y ?? 0);

		// heartImage
		const heartImage = scene.add.image(0, 0, "hud-icons", 138);
		heartImage.scaleX = 2;
		heartImage.scaleY = 2;
		this.add(heartImage);

		/* START-USER-CTR-CODE */
		// Write your code here.
		/* END-USER-CTR-CODE */
	}

	/* START-USER-CODE */

	// Write your code here.

	/* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
